import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutline";
import { IconButtonWithTooltip } from "react-admin";
import { useSimpleFormIterator } from "ra-core";

const AddCustomItemButton = ({ resetFields, ...rest }) => {
  const { add } = useSimpleFormIterator();

  return (
    <IconButtonWithTooltip
      label="ra.action.add"
      size="small"
      color="primary"
      {...rest}
      onClick={() => add(resetFields)}>
      <AddCircleOutlineRoundedIcon fontSize="small" />
    </IconButtonWithTooltip>
  );
};
export default AddCustomItemButton;
